<template>
	<form ref="frm" method="post" action="http://www.juso.go.kr/addrlink/addrLinkUrl.do">
		<input type="hidden" id="confmKey" name="confmKey" value="devU01TX0FVVEgyMDIwMDIxMjE5MzE1NzEwOTQ2MjI="/>
		<input type="hidden" ref="returnUrl" id="returnUrl" name="returnUrl" value=""/>
		<input type="hidden" id="resultType" name="resultType" value="4"/>
	</form>
</template>

<script>
export default {
	name: "ViewAddressSearch",
	mounted: function() {
		if(location.href.split("?").length>1) {
			location.href.split("?")[1].split("&").forEach(s => {
				this.getParameters[s.split("=")[0]] = s.substr(s.indexOf("="));
			})
		}

		// eslint-disable-next-line
		console.log("여기 안오나?", this.getParameters["inputYn"]);

		if(!this.getParameters["inputYn"] || (this.getParameters["inputYn"]&&this.getParameters["inputYn"]!="Y")) {
			// eslint-disable-next-line
			console.log("여기 왔잖아 111");
			this.init();
		}

		else if(this.getParameters["inputYn"]=="Y")
			this.confirm()
	},
	data: function() {
		return {
			getParameters: {}
		}
	},
	methods: {
		init: function() {
			this.$refs.returnUrl.value = location.href;
			// eslint-disable-next-line
			console.log("여기 왔잖아 2222", location.href);
			this.$refs.frm.submit();
		},
		confirm: function() {
			let ev = new Event("address");
			ev.zipcode = this.getParameters["zipNo"];
			ev.addr1 = this.getParameters["roadAddrPart1"];
			ev.addr2 = this.getParameters["roadAddrPart2"];
			this.window.opener.dispatchEvent(ev);
			this.window.close();
		}
	}
}
</script>